import { getAmplitudeInstance } from '../amplitudeHelpers';

type logCellCoverageModalViewedParams = {
  trail_id: number;
};

/**
 * Cell coverage modal viewed by the user
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - the id of the trail where the modal is viewed
 */
const logCellCoverageModalViewed = ({ trail_id }: logCellCoverageModalViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('cell coverage modal viewed', { 'trail id': trail_id }, callback);
};

export default logCellCoverageModalViewed;
